import { injectReducer } from '../../store/reducers'
import { ruleServerUrl } from 'configs/rule-server'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'facbook-campaign-insights',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const FacebookCampaignInsights = require('./containers/FacebookCampaingInsights').default
      // const fbCampaignInsightsReducer = require('components/FacebookCampaignInsights/reducers').default

      const FacebookLeadCampaignInsightsReducer = require('./modules/facebook-campaign-insights').default

      /*  Add the reducer to the store on key 'counter'  */
      // injectReducer(store, { key: 'counter', reducer })
      // injectReducer(store, {key: 'fbCampaignInsightsData', reducer: fbCampaignInsightsReducer})
      injectReducer(store, {key: 'fbCampaigns', reducer: FacebookLeadCampaignInsightsReducer})
      /*  Return getComponent   */
      cb(null, FacebookCampaignInsights)

      /* Webpack named bundle   */
    }, 'campaign')
  }
})



// WEBPACK FOOTER //
// ./src/routes/FacebookCampaignInsights/index.js